export const PrototypeTypes = {
  AcaciaI: "prototype.acaciaI",
  AcaciaIV: "prototype.acaciaIV",
  AcaciaXIX: "prototype.acaciaXIX",
};

export const FloorType = {
  LowFloor: "floor.lowFloor",
  TopFloor: "floor.topFloor",
  Terrace: "floor.terrace",
};

const prototypes = {
  [PrototypeTypes.AcaciaI]: {
    name: "prototype.acaciaI.name",
    terreno: "N/A", //264
    terrenoSqFt: "N/A", //2,841
    construccion: "N/A", //281.74
    construccionSqFt: "N/A", //3,033
    gallery: [
      "/assets/casas-velasur/Acacia I/Begonia.jpg",
      "/assets/casas-velasur/Acacia I/Begonia.jpg",
      "/assets/casas-velasur/Acacia I/Begonia.jpg",
      "/assets/casas-velasur/Acacia I/Begonia.jpg",
      "/assets/casas-velasur/Acacia I/Begonia.jpg",
      "/assets/casas-velasur/Acacia I/Begonia.jpg",
      "/assets/casas-velasur/Acacia I/Begonia.jpg",
    ],
    floor: {
      [FloorType.LowFloor]: {
        title: "floor.lowFloor",
        features: [
          { characteristics: "floor.features.proximamente", additional: "" },
          //{ characteristics: "floor.features.halfBath", additional: "" },
          //{ characteristics: "floor.features.serviceRoom", additional: "floor.features.withFullBath" },
          //{ characteristics: "floor.features.terraceGarden", additional: "" },
          //{ characteristics: "floor.features.parkingFor3Cars", additional: "" },
          //{ characteristics: "floor.features.grill", additional: "" },
          //{ characteristics: "floor.features.pool", additional: "floor.features.optionalExtraCost" },
          //{ characteristics: "floor.features.pergola", additional: "floor.features.optionalExtraCost" },
        ],
        floorImage: "/assets/casas-velasur/Acacia I/1.png",
      },
      [FloorType.TopFloor]: {
        title: "floor.topFloor",
        features: [
          { characteristics: "floor.features.proximamente", additional: "" },
          //{ characteristics: "floor.features.threeBathrooms", additional: "floor.features.includesDressingRoomBalcony" },
        ],
        floorImage: "/assets/casas-velasur/Acacia I/1.png",
      },
    },
  },
  [PrototypeTypes.AcaciaIV]: {
    name: "prototype.acaciaIV.name",
    terreno: "264",
    terrenoSqFt: "2,841",
    construccion: "237.83",
    construccionSqFt: "2,559",
    gallery: [
      "/assets/casas-velasur/Acacia iv/Magnolia_Fachada.jpg",
      "/assets/casas-velasur/Acacia iv/IMG_9722.jpg",
      "/assets/casas-velasur/Acacia iv/IMG_9709.jpg",
      "/assets/casas-velasur/Acacia iv/IMG_9703.jpg",
      "/assets/casas-velasur/Acacia iv/IMG_9691.jpg",
      "/assets/casas-velasur/Acacia iv/IMG_9689.jpg",
      "/assets/casas-velasur/Acacia iv/IMG_9673.jpg",
    ],
    floor: {
      [FloorType.LowFloor]: {
        title: "floor.lowFloor",
        surface: "107.63",
        features: [
          { characteristics: "floor.features.kitchenEquipped", additional: "" },
          { characteristics: "floor.features.fullBathroom", additional: "" },
          { characteristics: "floor.features.serviceRoom", additional: "floor.features.withFullBath" },
          { characteristics: "floor.features.terraceGarden", additional: "" },
          { characteristics: "floor.features.parkingFor3Cars", additional: "" },
          { characteristics: "floor.features.tvRoom", additional: "" },
          //{ characteristics: "floor.features.pool", additional: "floor.features.optionalExtraCost" },
          //{ characteristics: "floor.features.pergola", additional: "floor.features.optionalExtraCost" },
        ],
        floorImage: "/assets/casas-velasur/Acacia iv/img-acacia-iv-alta-casas-velasur.jpg",
      },
      [FloorType.TopFloor]: {
        title: "floor.topFloor",
        surface: "117.61",
        features: [
          { characteristics: "floor.features.threeBedrooms", additional: "" },
          { characteristics: "floor.features.threeBathrooms", additional: "floor.features.includesSharedBalcony" },
        ],
        floorImage: "/assets/casas-velasur/Acacia iv/img-acacia-iv-baja-casas-velasur.jpg",
      },
    },
  },
  [PrototypeTypes.AcaciaXIX]: {
    name: "prototype.acaciaXIX.name",
    terreno: "264",
    terrenoSqFt: "2,841",
    construccion: "190.65",
    construccionSqFt: "2,841", // Ajusta valor real si tienes dato correcto
    gallery: [
      "/assets/casas-velasur/acacia xix/Olivo_Fachada.jpg",
      "/assets/casas-velasur/acacia xix/IMG_6590.jpg",
      "/assets/casas-velasur/acacia xix/IMG_6574.jpg",
      "/assets/casas-velasur/acacia xix/IMG_6580.jpg",
      "/assets/casas-velasur/acacia xix/IMG_6582.jpg",
      "/assets/casas-velasur/acacia xix/IMG_6563.jpg",
      "/assets/casas-velasur/acacia xix/IMG_6555.jpg",
    ],
    floor: {
      [FloorType.LowFloor]: {
        title: "floor.lowFloor",
        surface: "128.65",
        features: [
          { characteristics: "floor.features.kitchenEquipped", additional: "" },
          { characteristics: "floor.features.bar", additional: "" },
          { characteristics: "floor.features.halfBath", additional: "" },
          { characteristics: "floor.features.laundryRoom", additional: "" },
          { characteristics: "floor.features.terraceGarden", additional: "" },
          { characteristics: "floor.features.parkingFor3Cars", additional: "" },
          //{ characteristics: "floor.features.pool", additional: "floor.features.optionalExtraCost" },
          //{ characteristics: "floor.features.pergola", additional: "floor.features.optionalExtraCost" },
        ],
        floorImage: "/assets/casas-velasur/acacia xix/img-acacia-xix-alta-casas-velasur.jpg",
      },
      [FloorType.TopFloor]: {
        title: "floor.topFloor",
        surface: "124.39",
        features: [
          { characteristics: "floor.features.threeBedrooms", additional: "" },
          { characteristics: "floor.features.threeBathrooms", additional: "floor.features.includesDressingRoomBalcony" },
        ],
        floorImage: "/assets/casas-velasur/acacia xix/img-acacia-xix-baja-casas-velasur.jpg",
      },
    },
  },
};

export const getPrototype = (prototypeType) => prototypes[prototypeType] ?? {};
